import { useMemo } from 'react'
import React from 'react'

import { Check, Circle } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { CommandGroup, CommandItem, CommandSeparator } from '@fortem-monorepo/react-ui'
import { Misc } from '@fortem-monorepo/web-sdk'

export interface StrategyIdOptionsProps {
  strategies?: Misc.GetStrategiesData
  value?: number | string | null
  onSelect?: (strategy: Misc.GetStrategiesData[number]) => void
}

export const StrategyIdOptions: React.FC<StrategyIdOptionsProps> = ({
  strategies,
  value,
  onSelect,
}) => {
  const strategyGroups = useMemo(() => {
    type Strategy = Misc.GetStrategiesData[number]
    type StrategyGroups = Record<string, Strategy[]>

    const _groups: StrategyGroups = (strategies ?? []).reduce((prev, current) => {
      const _new = { ...prev }

      if (!_new[current.strategy_type]) {
        _new[current.strategy_type] = [current]
      } else {
        _new[current.strategy_type].push(current)
      }

      return _new
    }, {} as StrategyGroups)

    return _groups
  }, [strategies])

  return (
    <>
      {Object.entries(strategyGroups)?.map(([label, strategies], index) => {
        const isFirst = index === 0

        return (
          <React.Fragment key={index}>
            {!isFirst && <CommandSeparator />}
            <CommandGroup heading={label}>
              {strategies?.map((strategy) => {
                const { strategy_name, strategy_id, active } = strategy
                const is_selected = strategy_id === value

                return (
                  <CommandItem
                    value={strategy_name?.toString()}
                    onSelect={() => {
                      onSelect?.(strategy)
                    }}
                    disabled={is_selected}
                    key={strategy.strategy_id}
                  >
                    <div className={'flex items-center gap-2 justify-between w-full'}>
                      <div className={'flex items-center gap-1'}>
                        <Circle
                          stroke={undefined}
                          className={cn('size-3', {
                            'fill-green-400/80': active,
                            'fill-red-400/80': !active,
                          })}
                        />
                        <span>{strategy_name}</span>
                      </div>
                      {value === strategy_id && (
                        <Check className={cn('text-green-700 ml-auto h-4 w-4')} />
                      )}
                    </div>
                  </CommandItem>
                )
              })}
            </CommandGroup>
          </React.Fragment>
        )
      })}
    </>
  )
}
